<template>
    <div class="resume">
        <!--<Header/>-->
        <el-container>
            <div class="content">
                <el-main class="main">
                    <el-form :model="formFields" class="demo-form-inline" :rules="rules" ref="resumeForm"
                             label-width="92px">
                        <el-row :gutter="20">
                            <el-col :span="21">
                                <!--个人信息-->
                                <div class="d_jump personalInfo">
                                    <el-row>
                                        <el-col :span="24">
                                            <h2 class="title">个人信息</h2>
                                        </el-col>
                                    </el-row>


                                    <el-row :gutter="10">
                                        <el-col :span="8">
                                            <el-form-item label="姓名" prop="name">
                                                <el-input v-model="formFields.name"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="性别" prop="sex">
                                                <el-radio-group v-model="formFields.sex">
                                                    <el-radio label="男"></el-radio>
                                                    <el-radio label="女"></el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="出生日期" prop="birthday">
                                                <el-date-picker type="date" placeholder="选择日期"
                                                                v-model="formFields.birthday"
                                                                value-format="yyyy-MM-dd"
                                                                :picker-options="pickerOptions"
                                                                style="width: 100%"></el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>



                                  <el-row>
                                    <el-col :span="12">
                                      <el-form-item label="应聘专业" prop="applyMajor">
                                        <el-cascader
                                          expand-trigger="hover"
                                          :options="optionsJob"
                                          v-model="formFields.applyMajor"
                                          @change="handleApplyMajorChange"
                                          style="width: 100%"
                                        >
                                        </el-cascader>
                                      </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                      <el-form-item label="意向工作地点" label-width="130px" prop="preferredWorkLocation">
                                        <el-select v-model="formFields.preferredWorkLocation" placeholder="请选择" style="width: 100%" clearable>
                                          <el-option label="北京" value="北京"></el-option>
                                          <el-option label="深圳/广州/佛山" value="深圳/广州/佛山"></el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>

                                    <el-row :gutter="10">
                                        <el-col :span="8">
                                            <el-form-item label="政治面貌" prop="politicalStatus">
                                                <el-select v-model="formFields.politicalStatus" placeholder="请选择">
                                                    <el-option label="中共党员" value="中共党员"></el-option>
                                                    <el-option label="预备党员" value="预备党员"></el-option>
                                                    <el-option label="共青团员" value="共青团员"></el-option>
                                                    <el-option label="群众" value="群众"></el-option>
                                                    <el-option label="中国国民党革命委员会" value="中国国民党革命委员会"></el-option>
                                                    <el-option label="九三学社" value="九三学社"></el-option>
                                                    <el-option label="中国民主同盟" value="中国民主同盟"></el-option>
                                                    <el-option label="中国民主建国会" value="中国民主建国会"></el-option>
                                                    <el-option label="中国民主促进会" value="中国民主促进会"></el-option>
                                                    <el-option label="中国农工民主党" value="中国农工民主党"></el-option>
                                                    <el-option label="中国致公党" value="中国致公党"></el-option>
                                                    <el-option label="台湾民主自治同盟" value="台湾民主自治同盟"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="身高" prop="height">
                                                <el-input v-model="formFields.height">
                                                    <template slot="append">cm</template>
                                                </el-input>

                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="健康状况" prop="healthCondition">
                                                <el-popover
                                                        ref="popover"
                                                        placement="right"
                                                        width="200"
                                                        trigger="click"
                                                        content="请选择，如有疾病应如实填写">
                                                </el-popover>
                                                <el-select
                                                        v-popover:popover
                                                        v-model="formFields.healthCondition"
                                                        filterable
                                                        allow-create
                                                        default-first-option
                                                        placeholder="请选择或填写">
                                                    <el-option label="健康" value="健康"></el-option>
                                                    <el-option label="一般" value="一般"></el-option>
                                                    <el-option label="较差" value="较差"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-form-item label="生源地" prop="fromWhere">
                                                <el-cascader
                                                        expand-trigger="hover"
                                                        :options="optionsProvinceAndCity"
                                                        v-model="formFields.fromWhere"
                                                        style="width: 100%">
                                                </el-cascader>

                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="身份证号" prop="idCard">
                                                <el-input v-model="formFields.idCard"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10">

                                        <el-col :span="12">
                                            <el-form-item label="户口所在地" prop="registeredResidence">
                                                <el-cascader
                                                        expand-trigger="hover"
                                                        :options="optionsProvinceAndCity"
                                                        v-model="formFields.registeredResidence"
                                                        style="width: 100%"
                                                >
                                                </el-cascader>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="邮编" prop="zipCode">
                                                <el-input v-model="formFields.zipCode" style="width: 100%"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10">
                                        <el-col :span="24">
                                            <el-form-item label="家庭住址" prop="homeAddress">
                                                <el-input v-model="formFields.homeAddress"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-form-item label="毕业院校" prop="fromSchool">
                                                <el-input v-model="formFields.fromSchool"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="专业" prop="major">
                                                <el-input v-model="formFields.major"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-form-item label="最高学历" prop="degree">
                                                <el-select v-model="formFields.degree" placeholder="请选择"
                                                           style="width: 100%">
                                                    <el-option label="大专" value="大专"></el-option>
                                                    <el-option label="本科" value="本科"></el-option>
                                                    <el-option label="研究生" value="研究生"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="最高学位" prop="degree2">
                                                <el-select v-model="formFields.degree2" placeholder="请选择"
                                                           style="width: 100%">
                                                    <el-option label="学士" value="学士"></el-option>
                                                    <el-option label="硕士" value="硕士"></el-option>
                                                    <el-option label="博士" value="博士"></el-option>
                                                    <el-option label="无" value="无"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="培养方式" prop="cultureMode">
                                                <el-select v-model="formFields.cultureMode" placeholder="请选择"
                                                           style="width: 100%">
                                                    <el-option label="统招" value="统招"></el-option>
                                                    <el-option label="委培" value="委培"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="英语水平" prop="score">
                                                <el-input v-model.number="formFields.score" class="input-with-select"
                                                          placeholder="分数">
                                                    <el-select v-model="formFields.englishLevel" slot="prepend"
                                                               placeholder="请选择" style="width: 120px;"
                                                               prop="englishLevel">
                                                        <el-option label="CET-4" value="CET-4"></el-option>
                                                        <el-option label="CET-6" value="CET-6"></el-option>
                                                        <el-option label="TEM-4" value="TEM-4"></el-option>
                                                        <el-option label="TEM-8" value="TEM-8"></el-option>
                                                    </el-select>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="手机号码" prop="mobilePhone">
                                                <el-input v-model="formFields.mobilePhone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                      <el-col :span="12">
                                        <el-form-item label="电子邮箱" prop="email">
                                          <el-input v-model="formFields.email"></el-input>
                                        </el-form-item>
                                      </el-col>
                                    </el-row>
                                    <el-row :gutter="10">

                                        <el-col :span="24">
                                            <el-form-item label="固定电话">
                                                <el-input v-model="formFields.fixedTelephone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="自我评价" prop="selfEvaluation">
                                                <el-input type="textarea" rows="4"
                                                          v-model="formFields.selfEvaluation"></el-input>
                                            </el-form-item>
                                            <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">500字以内</span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <!--工作/实习经历-->
                                <div class="d_jump work">
                                    <el-row>
                                        <el-col :span="24">
                                            <h2 class="title">工作/实习经历</h2>
                                        </el-col>
                                    </el-row>
                                    <div v-for="(experience, index) in formFields.fieWorkHistories" :key="index">
                                        <el-row>
                                            <el-col :span="24">
                                                <h3 class="titleWork"><i class="el-icon-edit icon"></i>工作经历-{{index+1}}
                                                    <span class="deleteMenu" v-if="index !== 0"
                                                          @click="onDeleteWork(index)"><i
                                                            class="el-icon-delete icon"></i></span>
                                                </h3>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-form-item label="工作时间"
                                                          :rules="[{required:true, message: '', trigger: ''}]">
                                                <el-col :span="8">
                                                    <el-form-item
                                                            :prop="'fieWorkHistories.' + index + '.workBeginTime'"
                                                            :rules="[{required:true, message: '请选择开始时间', trigger: 'blur'}]">
                                                        <el-date-picker
                                                                v-model="experience.workBeginTime"
                                                                type="month"
                                                                value-format="yyyy-MM"
                                                                placeholder="开始时间"
                                                                :picker-options="pickerOptionsBegin"
                                                                style="width: 100%"
                                                        >
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="1"><span>至</span></el-col>
                                                <el-col :span="8">
                                                    <el-form-item
                                                            :prop="'fieWorkHistories.' + index + '.workEndTime'"
                                                            :rules="[{required:true, message: '请选择结束时间', trigger: 'blur'}]"
                                                    >
                                                        <el-date-picker
                                                                v-model="experience.workEndTime"
                                                                type="month"
                                                                value-format="yyyy-MM"
                                                                placeholder="结束时间"
                                                                :picker-options="pickerOptionsEnd"
                                                                style="width: 100%"
                                                        >
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </el-col>
                                            </el-form-item>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="企业名称"
                                                              :prop="'fieWorkHistories.' + index + '.company'"
                                                              :rules="[{required:true, message: '请输入企业名称', trigger: 'blur'},
                                                                        {max:50, message: '您输入的内容过长', trigger: 'blur'}]">
                                                    <el-input v-model="experience.company"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="行业类别"
                                                              :prop="'fieWorkHistories.' + index + '.workType'"
                                                              :rules="[{required:true, message: '请输入行业类别', trigger: 'blur'},
                                                                       {max:50, message: '您输入的内容过长', trigger: 'blur'}
                                                          ]">
                                                    <el-input v-model="experience.workType"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="所在部门"
                                                              :prop="'fieWorkHistories.' + index + '.position'"
                                                              :rules="[{required:true, message: '请输入所在部门', trigger: 'blur'},
                                                               {max:50, message: '您输入的内容过长', trigger: 'blur'}
                                                              ]"
                                                >
                                                    <el-input v-model="experience.department"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="职位名称"
                                                              :prop="'fieWorkHistories.' + index + '.position'"
                                                              :rules="[{required:true, message: '请输入职位名称', trigger: 'blur'},
                                                               {max:50, message: '您输入的内容过长', trigger: 'blur'}
                                                              ]"
                                                >
                                                    <el-input v-model="experience.position"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item label="工作描述"
                                                              :prop="'fieWorkHistories.' + index + '.workDescribe'"
                                                              :rules="[{required:true, message: '请输入工作描述', trigger: 'blur'},
                                                                        {max:3000, message: '您输入的内容已超过3000字', trigger: 'blur'}
                                                                       ]">
                                                    <el-input type="textarea" rows="4"
                                                              v-model="experience.workDescribe"></el-input>
                                                </el-form-item>
                                                <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">3000字以内</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <el-button @click="addWordExperience" class="addmenu"><i
                                            class="el-icon-plus icon"></i>新增工作经历
                                    </el-button>
                                </div>
                                <!--项目经验-->
                                <div class="d_jump project">
                                    <el-row>
                                        <el-col :span="24">
                                            <h2 class="title">项目经验</h2>
                                        </el-col>
                                    </el-row>
                                    <div v-for="(project, index) in formFields.fieProjectHistories" :key="index">
                                        <el-row>
                                            <el-col :span="24">
                                                <h3 class="titleWork">
                                                    <i class="el-icon-edit icon"></i>
                                                    项目经验-{{index+1}}
                                                    <span class="deleteMenu" v-if="index !== 0"
                                                          @click="onDeleteProject(index)"><i
                                                            class="el-icon-delete icon"></i></span>
                                                </h3>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item label="项目时间"
                                                              :rules="[{required:true, message: '', trigger: ''}]">
                                                    <el-col :span="8">
                                                        <el-form-item
                                                                :prop="'fieProjectHistories.' + index + '.projectBeginTime'"
                                                                :rules="[{required:true, message: '请选择开始时间', trigger: 'blur'}]">
                                                            <el-date-picker
                                                                    v-model="project.projectBeginTime"
                                                                    type="month"
                                                                    value-format="yyyy-MM"
                                                                    placeholder="开始时间"
                                                                    :picker-options="pickerOptionsBegin"
                                                                    style="width: 100%"
                                                            >
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :span="1"><span>至</span></el-col>
                                                    <el-col :span="8">
                                                        <el-form-item
                                                                :prop="'fieProjectHistories.' + index + '.projectEndTime'"
                                                                :rules="[{required:true, message: '请选择结束时间', trigger: 'blur'}]"
                                                        >
                                                            <el-date-picker
                                                                    v-model="project.projectEndTime"
                                                                    type="month"
                                                                    value-format="yyyy-MM"
                                                                    placeholder="结束时间"
                                                                    :picker-options="pickerOptionsEnd"
                                                                    style="width: 100%"
                                                            >
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item label="项目名称"
                                                              :prop="'fieProjectHistories.' + index + '.projectName'"
                                                              :rules="[{required:true, message: '请输入项目名称', trigger: 'blur'},
                                                                       {max:100, message: '您输入的内容过长', trigger: 'blur'}
                                                          ]">
                                                    <el-input v-model="project.projectName"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item label="责任描述"
                                                              :prop="'fieProjectHistories.' + index + '.dutyDescribe'"
                                                              :rules="[{required:true, message: '请输入项目名称', trigger: 'blur'},
                                                                       {max:3000, message: '您输入的内容已超过3000字', trigger: 'blur'}
                                                          ]">
                                                    <el-input type="textarea" rows="4"
                                                              v-model="project.dutyDescribe"></el-input>
                                                </el-form-item>
                                                <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">3000字以内</span>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item label="项目描述"
                                                              :prop="'fieProjectHistories.' + index + '.projectDescribe'"
                                                              :rules="[{required:true, message: '请输入项目描述', trigger: 'blur'},
                                                                       {max:3000, message: '您输入的内容已超过3000字', trigger: 'blur'}
                                                          ]">
                                                    <el-input type="textarea" rows="4"
                                                              v-model="project.projectDescribe"></el-input>
                                                </el-form-item>
                                                <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">3000字以内</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <el-button @click="addProject" class="addmenu"><i class="el-icon-plus icon"></i>新增项目经验
                                    </el-button>
                                </div>
                                <!--教育经历-->
                                <div class="d_jump education">
                                    <el-row>
                                        <el-col :span="24">
                                            <h2 class="title">教育经历</h2>
                                        </el-col>
                                    </el-row>
                                    <div v-for="(edu, index) in formFields.fieEducateHistories" :key="index">
                                        <el-row>
                                            <el-col :span="24">
                                                <h3 class="titleWork"><i class="el-icon-edit icon"></i>教育经历-{{index+1}}
                                                    <span class="deleteMenu" v-if="index !== 0"
                                                          @click="onDeleteEdu(index)"><i
                                                            class="el-icon-delete icon"></i></span>
                                                </h3>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item label="起止时间"
                                                              :rules="[{required:true, message: '', trigger: ''}]">
                                                    <el-col :span="8">
                                                        <el-form-item
                                                                :prop="'fieEducateHistories.' + index + '.eduBeginTime'"
                                                                :rules="[{required:true, message: '请选择开始时间', trigger: 'blur'}]">
                                                            <el-date-picker
                                                                    v-model="edu.eduBeginTime"
                                                                    type="month"
                                                                    value-format="yyyy-MM"
                                                                    placeholder="开始时间"
                                                                    :picker-options="pickerOptionsBegin"
                                                                    style="width: 100%"
                                                            >
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :span="1"><span>至</span></el-col>
                                                    <el-col :span="8">
                                                        <el-form-item
                                                                :prop="'fieEducateHistories.' + index + '.eduEndTime'"
                                                                :rules="[{required:true, message: '请选择结束时间', trigger: 'blur'}]"
                                                        >
<!--                                                            :picker-options="pickerOptionsEnd"-->
                                                            <el-date-picker
                                                                    v-model="edu.eduEndTime"
                                                                    type="month"
                                                                    value-format="yyyy-MM"
                                                                    placeholder="结束时间"

                                                                    style="width: 100%"
                                                            >
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="学校名称"
                                                              :prop="'fieEducateHistories.' + index + '.schoolName'"
                                                              :rules="[{required:true, message: '请输入学校名称', trigger: 'blur'},
                                                                       {max:50, message: '您输入的内容过长', trigger: 'blur'}
                                                          ]">
                                                    <el-input v-model="edu.schoolName"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="学历名称"
                                                              :prop="'fieEducateHistories.' + index + '.degree'"
                                                              :rules="[{required:true, message: '请选择学历名称', trigger: 'blur'}
                                                          ]">
                                                    <el-select v-model="edu.degree" placeholder="请选择"
                                                               style="width: 100%">
                                                        <el-option label="大专" value="大专"></el-option>
                                                        <el-option label="本科" value="本科"></el-option>
                                                        <el-option label="硕士" value="硕士研究生"></el-option>
                                                        <el-option label="博士" value="博士研究生"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="专业名称"
                                                              :prop="'fieEducateHistories.' + index + '.majorName'"
                                                              :rules="[{required:true, message: '请输入专业名称', trigger: 'blur'},
                                                                       {max:50, message: '您输入的内容过长', trigger: 'blur'}
                                                          ]">
                                                    <el-input v-model="edu.majorName"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="证明人" prop="proveMan">
                                                    <el-input v-model="edu.proveMan"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <el-button @click="addEdu" class="addmenu"><i class="el-icon-plus icon"></i>新增教育经历
                                    </el-button>
                                </div>
                                <!--附加信息-->
                                <div class="d_jump exInfo">
                                    <el-row>
                                        <el-col :span="24">
                                            <h2 class="title">附加信息</h2>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="获奖情况" prop="awardWinning">
                                                <el-input type="textarea" rows="4"
                                                          v-model="formFields.awardWinning"></el-input>
                                            </el-form-item>
                                            <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">200字以内</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="发表论文情况" prop="paper">
                                                <el-input type="textarea" rows="4"
                                                          v-model="formFields.paper"></el-input>
                                            </el-form-item>
                                            <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">200字以内</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="专业资格证书情况" prop="qualificationCertificate">
                                                <el-input type="textarea" rows="4"
                                                          v-model="formFields.qualificationCertificate"></el-input>
                                            </el-form-item>
                                            <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">200字以内</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="社会职务及任职情况" prop="societyWork">
                                                <el-input type="textarea" rows="4"
                                                          v-model="formFields.societyWork"></el-input>
                                            </el-form-item>
                                            <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">200字以内</span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="兴趣爱好" prop="interest">
                                                <el-input type="textarea" rows="2"
                                                          v-model="formFields.interest"></el-input>
                                            </el-form-item>
                                            <span style="float: right;color: #abb6b6;font-size: 14px;margin-top: -18px">100字以内</span>
                                        </el-col>
                                    </el-row>
                                </div>

                                <!--上传附件-->
                                <div class="d_jump">
                                    <el-row :gutter="10">
                                        <el-row>
                                            <el-col :span="24">
                                                <h2 class="title">上传附件</h2>
                                            </el-col>
                                        </el-row>
                                        <el-col :span="24">
                                            <el-form-item label="附件简历" :required="true">
                                                <el-upload
                                                        :multiple="false"
                                                        drag
                                                        :on-success="handleFileSuccess"
                                                        :action="url + '/api/web/fileManager/file/upload'"
                                                        :data="{guid:formFields.guid}"
                                                        :limit="1"
                                                        :on-exceed="onFileExceed"
                                                        :before-upload="beforeFileUpload"
                                                >
                                                    <i class="el-icon-upload"></i>
                                                    <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                                                    <div class="el-upload__tip" slot="tip">
                                                        *简历命名规则：“专业名称-毕业院校-学历-姓名”；简历应为*.doc或*.docx格式，且大小不超过3M！
                                                    </div>
                                                </el-upload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                            <el-col :span="3">
                                <div class="imgBox" v-if="!imgDataUrl">
                                    <p><span>*&nbsp;</span>照片</p>
                                </div>
                                <img v-if="imgDataUrl" :src="imgDataUrl" class="avatar">

                                <el-button size="mini" type="primary" class="uploadBtn" @click="toggleShow">上传照片
                                </el-button>
                                <photo-upload field="file"
                                              @crop-success="cropSuccess"
                                              v-model="show"
                                              :width="295"
                                              :height="413"
                                              :url="url + '/api/web/fileManager/file/upload'"
                                              :params="{guid:formFields.guid}"
                                              img-format="jpg"
                                              :no-circle="true"
                                ></photo-upload>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <el-form-item label-width="0">
                                    <p class="declare">
                                        <span class="redwords">申明：</span>通过本申请表所收集的个人信息，仅用于评估应聘者是否适合担任所申请的职位，不会向第三方提供。
                                    </p>
                                    <el-button type="primary" @click="onSubmit('resumeForm')" class="submit">确认提交
                                    </el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-main>
                <div class="rightNav">
                    <el-menu
                            :default-active="defaultActive"
                            class="el-menu-vertical-demo"
                            track-by="$index">
                        <el-menu-item index="1" @click.native="jump(0)">
                            <i class="el-icon-menu"></i>
                            <span slot="title">个人信息</span>
                        </el-menu-item>
                        <el-menu-item index="2" @click.native="jump(1)">
                            <i class="el-icon-phone"></i>
                            <span slot="title">工作经历</span>
                        </el-menu-item>
                        <el-menu-item index="3" @click.native="jump(2)">
                            <i class="el-icon-document"></i>
                            <span slot="title">项目经验</span>
                        </el-menu-item>
                        <el-menu-item index="4" @click.native="jump(3)">
                            <i class="el-icon-edit"></i>
                            <span slot="title">教育经历</span>
                        </el-menu-item>
                        <el-menu-item index="5" @click.native="jump(4)">
                            <i class="el-icon-plus"></i>
                            <span slot="title">附加信息</span>
                        </el-menu-item>
                        <el-menu-item index="6" @click.native="jump(5)">
                            <i class="el-icon-upload"></i>
                            <span slot="title">上传附件</span>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
        </el-container>

        <Footer/>
    </div>
</template>

<script>
    import Header from '../base/Header'
    import Footer from '../base/Footer'
    import {addResume, getMajorList} from '../api'
    import photoUpload from 'vue-image-crop-upload'
    import {CodeToText, provinceAndCityData,} from 'element-china-area-data'


    export default {
        name: 'Resume',
        props: {
            msg: String
        },
        components: {
            Header, Footer, 'photo-upload': photoUpload
        },
        computed: {},
        data() {
            return {
              // url: "http://192.168.109.4:8888/zp",
              url: "",
                show: false,
                imgDataUrl: null,
                pickerOptions: {
                    disabledDate(time) {
                        let year16 = (365 * 16 + 4) * 24 * 3600 * 1000;
                        return time.getTime() > Date.now() - year16;
                    }
                },
                pickerOptionsBegin: {
                    disabledDate: (time) => {
                        return time.getTime() > Date.now();
                    }
                },
                pickerOptionsEnd: {
                    disabledDate: (time) => {
                        return time.getTime() > Date.now();
                    }
                },
                rules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {min: 2, max: 20, message: '请输入正确的中文姓名', trigger: 'blur'}
                    ],
                    sex: [
                        {required: true, message: '请选择性别', trigger: 'change'}
                    ],
                    birthday: [
                        {required: true, message: '请选择日期', trigger: 'blur'}
                    ],
                    politicalStatus: [
                        {required: true, message: '请选择政治面貌', trigger: 'change'},
                    ],
                    height: [
                        {required: true, message: '请输入身高', trigger: 'blur'},
                        {min: 3, max: 3, message: '请输入正确的身高', trigger: 'blur'}
                    ],
                    healthCondition: [
                        {required: true, message: '请填写健康状况', trigger: 'blur'},
                    ],
                    idCard: [
                        {required: true, message: '请输入身份证号', trigger: 'blur'},
                        {len: 18, message: '请输入正确的身份证号', trigger: 'blur'}
                    ],
                    registeredResidence: [
                        {required: true, message: '请选择户口所在地', trigger: 'change'},
                    ],
                    zipCode: [
                        {len: 6, message: '请输入正确格式的邮编', trigger: 'blur'}
                    ],

                    homeAddress: [
                        {required: true, message: '请填写家庭住址', trigger: 'blur'},
                    ],
                    major: [
                        {required: true, message: '请填写所学专业', trigger: 'blur'},
                    ],
                    fromSchool: [
                        {required: true, message: '请填写毕业院校', trigger: 'blur'},
                    ],
                    degree: [
                        {required: true, message: '请选择最高学历', trigger: 'change'},
                    ],
                    degree2: [
                        {required: true, message: '请选择最高学位', trigger: 'change'},
                    ],
                    cultureMode: [
                        {required: true, message: '请选择培养方式', trigger: 'change'},
                    ],
                    score: [
                        {required: true, message: '请选择英语水平并填写分数', trigger: 'blur'},
                        {type: 'number', message: '请填写正确的分数', trigger: 'blur'},
                    ],
                    mobilePhone: [
                        {required: true, message: '请填写手机号码', trigger: 'blur'},
                        {len: 11, message: '请填写正确的手机号码', trigger: 'blur'},
                    ],
                    email: [
                        {required: true, message: '请填写邮箱', trigger: 'blur'},
                        {type: 'email', message: '请填写正确的邮箱', trigger: 'blur'},
                    ],
                  preferredWorkLocation: [
                    {required: true, message: '请选择意向工作地点', trigger: 'change'}
                  ],
                    applyMajor: [
                        {required: true, message: '请选择应聘专业', trigger: 'change'},
                    ],
                    selfEvaluation: [
                        {max: 500, message: '您输入的内容已超过500字', trigger: 'change'},
                    ],
                    annex: [
                        {required: true, message: '请上传简历附件', trigger: 'change'},
                    ],
                    awardWinning: [
                        {max: 200, message: '您输入的内容已超过200字', trigger: 'change'},
                    ],
                    paper: [
                        {max: 200, message: '您输入的内容已超过200字', trigger: 'change'},
                    ],
                    qualificationCertificate: [
                        {max: 200, message: '您输入的内容已超过200字', trigger: 'change'},
                    ],
                    societyWork: [
                        {max: 200, message: '您输入的内容已超过200字', trigger: 'change'},
                    ],
                    interest: [
                        {max: 100, message: '您输入的内容已超过100字', trigger: 'change'},
                    ],

                },
                optionsJob: [],
                job: [],
                fromWhere: [],
                registeredResidence: [],
                optionsProvinceAndCity: provinceAndCityData,
                defaultActive: '1',
                annex: null,
                formFields: {
                    addTime: "",
                    addUserGuid: "",
                    applyMajor: [],
                    awardWinning: "",
                    birthday: "",
                    cultureMode: "",
                    degree: "",
                    degree2: "",
                    email: "",
                    englishLevel: "",
                    score: "",
                    preferredWorkLocation: "",
                    fieEducateHistories: [
                        {
                            addTime: "",
                            degree: "",
                            eduBeginTime: "",
                            eduEndTime: "",
                            empGuid: "",
                            flag: 0,
                            guid: "",
                            majorName: "",
                            proveMan: "",
                            schoolName: "",
                            sortNo: 0,
                            updateTime: ""
                        }
                    ],
                    fieProjectHistories: [
                        {
                            addTime: "",
                            empGuid: "",
                            flag: 0,
                            guid: "",
                            projectBeginTime: "",
                            projectEndTime: "",
                            projectName: "",
                            sortNo: 0,
                            updateTime: "",
                            dutyDescribe: "",
                            projectDescribe: ""
                        }
                    ],
                    fieWorkHistories: [
                        {
                            addTime: "",
                            company: "",
                            department: "",
                            empGuid: "",
                            flag: 0,
                            guid: "",
                            position: "",
                            sortNo: 0,
                            updateTime: "",
                            workBeginTime: "",
                            workDescribe: "",
                            workEndTime: "",
                            workType: ""
                        }
                    ],
                    fixedTelephone: "",
                    flag: 0,
                    fromSchool: "",
                    fromWhere: [],
                    guid: this.creatGuid(),
                    healthCondition: "",
                    height: "",
                    homeAddress: "",
                    idCard: "",
                    interest: "",
                    isFlag: 0,
                    major: "",
                    mobilePhone: "",
                    name: "",
                    paper: "",
                    politicalStatus: "",
                    qualificationCertificate: "",
                    registeredResidence: [],
                    selfEvaluation: "",
                    sex: "",
                    societyWork: "",
                    updateTime: "",
                    updateUserGuid: "",
                    zipCode: ""
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('scroll', this.onScroll)
            });
            this.queryMajor();
        },

        methods: {
            queryMajor() {
                getMajorList().then((res) => {
                    const {content} = res;
                    let data = [];
                    //专业类别循环
                    for (let i = 0; i < content.length; i++) {
                        const majorType = content[i];
                        data.push({id: majorType.code, label: majorType.name, value: majorType.name, children: []});

                        if (majorType.list.length > 0) {
                            //类别中的专业循环
                            for (let j = 0; j < majorType.list.length; j++) {
                                const item = majorType.list[j];
                                data[i].children.push({id: item.code, label: item.name, value: item.name});
                            }
                            //专业按照id升序排列
                            data[i].children.sort((a, b) => (a.id - b.id))
                        }
                    }
                    //专业类别按照id升序排列
                    data.sort((a, b) => (a.id - b.id));
                    this.optionsJob = JSON.parse(JSON.stringify(data));
                })
            },

            toggleShow() {
                this.show = !this.show;
            },

            cropSuccess(imgDataUrl, field) {
                this.imgDataUrl = imgDataUrl;
            },

            handleApplyMajorChange(value) {
                if (!value) {
                    this.formFields.applyMajor = value[1];
                }
            },

            onSubmit(formName) {
                if (!this.imgDataUrl) {
                    this.$alert('您的照片还未上传！', '提示', {
                        type: 'warning',
                    });
                    return false;
                }
                if (!this.annex) {
                    this.$alert('您的附件简历还未上传！', '提示', {
                        type: 'warning',
                    });
                    return false;
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formResume = JSON.parse(JSON.stringify(this.formFields));
                        formResume.applyMajor = formResume.applyMajor.join('-');
                        formResume.major = formResume.major.replace(/\//g,'-');

                        let registeredResidence = formResume.registeredResidence;//户口
                        let fromWhere = formResume.fromWhere; //生源
                        if (registeredResidence.length === 2) {
                            formResume.registeredResidence = CodeToText[registeredResidence[0]] + CodeToText[registeredResidence[1]]
                        } else {
                            formResume.registeredResidence = '';
                        }

                        if (fromWhere.length === 2) {
                            formResume.fromWhere = CodeToText[fromWhere[0]] + CodeToText[fromWhere[1]]
                        } else {
                            formResume.fromWhere = '';
                        }


                        let work = this.formFields.fieWorkHistories;
                        for (let i = 0; i<work.length;i++){
                            if(new Date(work[i].workBeginTime) -  new Date(work[i].workEndTime) > 0){
                                this.$alert('工作开始时间不能大于结束时间！', '提示', {
                                    type: 'warning',
                                });
                                return;
                            }
                        }

                        let project = this.formFields.fieProjectHistories;
                        for (let i = 0; i<project.length;i++){
                            if(new Date(project[i].projectBeginTime) -  new Date(project[i].projectEndTime) > 0){
                                this.$alert('项目开始时间不能大于结束时间！', '提示', {
                                    type: 'warning',
                                });
                                return;
                            }
                        }

                        let Educate = this.formFields.fieEducateHistories;
                        for (let i = 0; i<Educate.length;i++){
                            if(new Date(Educate[i].eduBeginTime) -  new Date(Educate[i].eduEndTime) > 0){
                                this.$alert('教育开始时间不能大于结束时间！', '提示', {
                                    type: 'warning',
                                });
                                return;
                            }
                        }

                        this.$confirm('确定提交简历?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            addResume(formResume).then((res) => {
                                let {message, code} = res;
                                if (code === 1) {
                                    this.$message({
                                        message: "提交成功",
                                        type: 'success'
                                    });


                                    this.$confirm('简历提交成功', '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        showClose: false,
                                        showCancelButton: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false,
                                        closeOnHashChange: false
                                    }).then(() => {
                                        this.$router.push('/home');
                                    })

                                } else if (code === -1) {
                                    this.$message({
                                        message: message,
                                        type: 'error',
                                    });
                                }
                            });
                        })



                    } else {
                        alert('请检查必填字段！');
                        return false;
                    }
                });
            },
            jump(index) {
                // 用 class="d_jump" 添加锚点
                let jump = document.querySelectorAll('.d_jump');
                let total = jump[index].offsetTop;
                let distance = document.documentElement.scrollTop || document.body.scrollTop;
                // 平滑滚动
                let step = total / 20;
                if (total > distance) {
                    smoothDown()
                } else {
                    let newTotal = distance - total;
                    step = newTotal / 20;
                    smoothUp()
                }

                function smoothDown() {
                    if (distance < total) {
                        distance += step;
                        document.body.scrollTop = distance;
                        document.documentElement.scrollTop = distance;
                        setTimeout(smoothDown, 10);
                    } else {
                        document.body.scrollTop = total;
                        document.documentElement.scrollTop = total;
                    }
                }

                function smoothUp() {
                    if (distance > total) {
                        distance -= step;
                        document.body.scrollTop = distance;
                        document.documentElement.scrollTop = distance;
                        setTimeout(smoothUp, 10);
                    } else {
                        document.body.scrollTop = total;
                        document.documentElement.scrollTop = total;
                    }
                }

            },
            onScroll() {
                let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
                let jump = document.querySelectorAll('.d_jump');

                if (jump.length <= 0) {
                    return;
                }
                if (scrolled >= jump[5].offsetTop - 300) {
                    this.defaultActive = "6"
                } else if (scrolled < jump[5].offsetTop - 200 && scrolled >= jump[4].offsetTop - 200) {
                    this.defaultActive = "5"
                } else if (scrolled < jump[4].offsetTop - 200 && scrolled >= jump[3].offsetTop - 200) {
                    this.defaultActive = "4"
                } else if (scrolled < jump[3].offsetTop - 200 && scrolled >= jump[2].offsetTop - 200) {
                    this.defaultActive = "3"
                } else if (scrolled < jump[2].offsetTop - 200 && scrolled >= jump[1].offsetTop - 200) {
                    this.defaultActive = "2"
                } else {
                    this.defaultActive = "1"
                }
            },
            addProject() {
                this.formFields.fieProjectHistories.push(
                    {
                        addTime: "",
                        empGuid: "",
                        flag: 0,
                        guid: "",
                        projectBeginTime: "",
                        projectEndTime: "",
                        projectName: "",
                        sortNo: 0,
                        updateTime: "",
                        dutyDescribe: "",
                        projectDescribe: ""
                    });
            },
            addEdu() {
                this.formFields.fieEducateHistories.push(
                    {
                        addTime: "",
                        degree: "",
                        eduBeginTime: "",
                        eduEndTime: "",
                        empGuid: "",
                        flag: 0,
                        guid: "",
                        majorName: "",
                        proveMan: "",
                        schoolName: "",
                        sortNo: 0,
                        updateTime: ""
                    }
                )
            },
            addWordExperience() {
                this.formFields.fieWorkHistories.push(
                    {
                        addTime: "",
                        company: "",
                        department: "",
                        empGuid: "",
                        flag: 0,
                        guid: "",
                        position: "",
                        sortNo: 0,
                        updateTime: "",
                        workBeginTime: "",
                        workDescribe: "",
                        workEndTime: "",
                        workType: ""
                    })
            },
            onDeleteProject(i) {
                this.formFields.fieProjectHistories = this.formFields.fieProjectHistories.filter((item, index) => {
                    return i !== index;
                })
            },
            onDeleteEdu(i) {
                this.formFields.fieEducateHistories = this.formFields.fieEducateHistories.filter((item, index) => {
                    return i !== index;
                })
            },
            onDeleteWork(i) {
                this.formFields.fieWorkHistories = this.formFields.fieWorkHistories.filter((item, index) => {
                    return i !== index;
                })
            },
            handleFileSuccess(res, file) {
                this.annex = URL.createObjectURL(file.raw);
            },
            beforeFileUpload(file) {
                // const isDOC = file.type === 'application/msword'
                //     || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                //     || file.type === 'application/kswps';
                const suffix = file.name.substring(file.name.lastIndexOf('.')+1)
                const isDOC = (suffix === 'doc') || (suffix === 'docx')

                const isLt3M = file.size / 1024 < 3072;
                if (!isDOC) {
                    this.$message.error('上传附件简历只能是*.doc或*.docx格式');
                }
                if (!isLt3M) {
                    this.$message.error('上传附件简历的大小不能超过3M');
                }
                return isDOC && isLt3M
            },
            creatGuid() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1).toUpperCase();
                }

                return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
            }
            ,
            onFileExceed() {
                this.$message.warning('您已添加了附件简历，请勿重复添加!')
            }
        }

    }
</script>

<style scoped lang="less">
    .resume{
        min-width: 1280px;
    }

    .content {
        margin: 0 auto;
    }

    .main {
        width: 900px;
        box-sizing: border-box;
        position: relative;
        margin: 80px auto 20px;
        padding: 20px 40px;
        background: #FFF;
        float: left;
    }

    .title {
        font-size: 18px;
        margin-bottom: 20px;
        float: left;
        border-left: 5px solid #2e679c;
        padding-left: 20px;
    }

    .titleWork {
        font-size: 16px;
        margin-bottom: 20px;
        float: left;
        padding-left: 10px;

        .icon {
            color: #2e679c;
            margin-right: 10px;
        }
    }

    .imgBox {
        width: 100px;
        height: 130px;
        border-radius: 5px;
        border: 1px dashed #ccc;
        margin-top: 40px;

        p {
            margin-top: 60px;
            font-size: 14px;
            color: #606266;
            span {
                color: red
            }
        }
    }

    .avatar {
        width: 100px;
        height: 130px;
        border-radius: 5px;
        display: block;
        margin-top: 40px;
    }

    .uploadBtn {
        margin: 10px 0 0 12px;
    }

    .rightNav {
        position: fixed;
        display: inline-block;
        width: 160px;
        top: 80px;
        float: right;
        margin-left: 20px;
        text-align: left;
    }

    .d_jump {
        margin-bottom: 30px;
    }

    .deleteMenu {
        margin: 0 30px;
        cursor: pointer;
        .icon {
            color: #409eff;
        }
    }

    .addmenu {
        color: #409eff;
    }

    .declare {
        text-align: center;
        font-size: 14px;
        color: #333;
        line-height: 30px;
        margin-bottom: 20px;
        padding: 18px;
        border: 1px dashed #ccc;
        .redwords {
            color: red;
        }
    }

    .submit {
        width: 120px;
        border-radius: 20px;
    }


</style>
<style lang="less">
    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        margin-top: 38px;
        .words {
            position: absolute;
            font-size: 14px;
            color: #8c939d;
            top: 90px;
            left: 22px;
        }
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 130px;
        line-height: 130px !important;
        text-align: center;
    }

    .vue-image-crop-upload {
        .vicp-wrap {
            .vicp-operate a {
                color: #409eff !important;
            }
        }
        .vicp-step1 {
            .vicp-drop-area {
                border-radius: 10px;
                background: #FFF !important;
                border-color: #d9d9d9 !important;
                &:hover {
                    border-color: #409eff !important;
                }
                .vicp-icon1 {
                    width: 68px !important;
                    height: 52px !important;
                    background-image: url('../assets/upload.png');
                    background-size: 100% 100%;

                    .vicp-icon1-arrow, .vicp-icon1-body, .vicp-icon1-bottom {
                        display: none !important;
                    }
                }
            }
        }
    }
</style>
